/***************************************************************
5/22/2017
Alexander Self
Timesheet View individual
- Displays individual timesheet summaries
Anyone who has a subtimesheet len > 0 is displayed with a work table
***************************************************************/
import React from 'react';
import moment from 'moment';
import TimesheetWorkTable from '../create/timesheet_modal_work_table';
import TimesheetHarvestViewTable from './timesheet_harvest_view_table';
const TimesheetIndividualSummaryView = ({ ts }) => {
  return (
    <div className="card horizontal z-depth-4">
      <div className="card-stacked">
        <div className="card-content">
          <div>
            <div className="row ind-summary">
              <div className="col s12 m6 l6">
                <ul className="collection">
                  <li className="collection-item flow-text">Name: <b><span className="right">{ts.firstName} {ts.lastName}</span></b></li>
                  <li className="collection-item flow-text">EID <b><span className="right">{ ts.eid }</span></b></li>
                  <li className="collection-item flow-text">Reg. Hours: <b><span className="right">{ ts.regHours }</span></b></li>
                  <li className="collection-item flow-text">OT Hours: <b><span className="right">{ ts.otHours }</span></b></li>
                  <li className="collection-item flow-text">Doubletime Hours: <b><span className="right">{ ts.doubleTime }</span></b></li>
                  <li className="collection-item flow-text ">Non-work Hours: <b><span className="right"><u>{ ts.miscHours }</u></span></b></li>
                  <li className="collection-item flow-text ">Total Hours: <b><span className="right"><u>{ ts.summaryOfHours }</u></span></b></li>
                </ul>
              </div>
              <div className="col s12 m6 l6">
                <ul className="collection">
                  <li className="collection-item flow-text">Start Time: <b><span className="right">{ ts.startTime }</span></b></li>
                  <li className="collection-item flow-text">End Time: <b><span className="right">{ ts.endTime }</span></b></li>
                  <li className="collection-item flow-text">Grade: <b><span className="right">{ts.grade}</span></b></li>
                  <li className="collection-item flow-text">Shift: <b><span className="right">{ ts.shift }</span></b></li>
                  <li className="collection-item flow-text">Location: <b><span className="right">{ ts.location }</span></b></li>
                  <li className="collection-item flow-text">Team <b><span className="right">{ ts.gang }</span></b></li>
                  { ts.dustPay ?
                    <li className="collection-item flow-text">Dust Pay <b><span className="right error">Active</span></b></li>
                  : '' }
                </ul>
              </div>
            </div>
          </div>
          <h5>{ ts.reasonForEdit ? <div>Timesheet Edited: <span className="blue-text">{moment(ts.dateTimeEdited).format('YYYY-MM-DD hh:mm:ss a')}, { ts.reasonForEdit }</span></div> : '' }</h5>
        </div>
        <div className="card-action">
          { ts.subTimesheet.length > 0 ? <TimesheetWorkTable workPerformed={ts.subTimesheet} /> : '' }
          { ts.harvest.length > 0 ? <TimesheetHarvestViewTable harvest={ts.harvest} /> : '' }
        </div>
      </div>
    </div>
  );
};

export default TimesheetIndividualSummaryView;




























/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/view/timesheet_view_individual_summary.js